import { render, staticRenderFns } from "./integralGoodsorder.vue?vue&type=template&id=4bb2a6c3&scoped=true&"
import script from "./integralGoodsorder.vue?vue&type=script&lang=js&"
export * from "./integralGoodsorder.vue?vue&type=script&lang=js&"
import style0 from "./integralGoodsorder.vue?vue&type=style&index=0&id=4bb2a6c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb2a6c3",
  null
  
)

export default component.exports